import { useEffect } from "react";
import { Switch, Route, Redirect, useLocation } from "react-router-dom";

import Dashboards from "./subpages/Dashboards";
import CreateDashboard from "./subpages/CreateDashboard";
import EditDashboard from "./subpages/EditDashboard";
import Notification from "./common/Notification";
import Navbar from "./common/Navbar";
import { useDispatch, useSelector } from "react-redux";
import { authenticateUser } from "../../store/slices/authenticateuser";
import Goals from "./Goals";
import GoalsArchive from "./goals/GoalsArchive";
import CreateGoal from "./goals/CreateGoal";
import EditGoal from "./goals/EditGoal";

type UserState = {
	data: {
		superUser: boolean;
		features: string[];
		loggedIn: boolean;
	};
	isLoading: boolean;
};

const Admin = () => {
	const { pathname } = useLocation();
	const data = useSelector((state: { authenticateuser: UserState }) => state.authenticateuser.data);
	const isLoading = useSelector((state: { authenticateuser: UserState }) => state.authenticateuser.isLoading);
	const canAccessGoals = data.features?.includes("goals");
	const isSuperUser = data.superUser;
	const dispatch = useDispatch();

	useEffect(() => {
		function hideError(e: ErrorEvent) {
			if (e.message === 'ResizeObserver loop completed with undelivered notifications.') {
				console.error(e);
				const resizeObserverErrDiv = document.getElementById(
					'webpack-dev-server-client-overlay-div'
				);
				const resizeObserverErr = document.getElementById(
					'webpack-dev-server-client-overlay'
				);
				if (resizeObserverErr) {
					resizeObserverErr.setAttribute('style', 'display: none');
				}
				if (resizeObserverErrDiv) {
					resizeObserverErrDiv.setAttribute('style', 'display: none');
				}
			}
		}

		window.addEventListener('error', hideError)
		return () => {
			window.addEventListener('error', hideError)
		}
	}, [])

	useEffect(() => {
		dispatch(authenticateUser());
	}, [dispatch]);


	if (isLoading) {
		return <></>
	}

	return (
		<div className="admin">
			<Navbar />
			<Switch>
				{/*This redirect is used to remove trailing slash from url*/}
				<Redirect from="/:url*(/+)" to={pathname.slice(0, -1)} />
				<Route exact path="/admin" render={() => <Dashboards isSuperUser={isSuperUser} />} />
				<Route
					exact
					path="/admin/goals"
					render={() => (canAccessGoals ? <Goals isSuperUser={isSuperUser} /> : <Redirect to="/admin" />)}
				/>
				{Object.keys(data).length > 0 &&
					(isSuperUser ? (
						canAccessGoals ? (
							<Switch>
								<Route exact path="/admin/create-dashboard" component={CreateDashboard} />
								<Route exact path="/admin/edit-dashboard/:id" component={EditDashboard} />
								<Route exact path="/admin/create-goal" component={CreateGoal} />
								<Route exact path="/admin/edit-goal/:id" component={EditGoal} />
								<Route exact path="/admin/archive/:id" component={GoalsArchive} />
							</Switch>
						) : (
							<Switch>
								<Route exact path="/admin/create-dashboard" component={CreateDashboard} />
								<Route exact path="/admin/edit-dashboard/:id" component={EditDashboard} />
							</Switch>
						)
					) : (
						<Redirect to="/admin" />
					))}
			</Switch>
			<Notification />
		</div>
	);
};

//export default Admin;

export default Admin;
